


const CsPriceRange = (function () {
  var defaultStep = 10;
  var selectors = {
    priceRange: '.price-range',
    priceRangeSlider: '.price-range__slider',
    priceRangeInputMin: '.price-range__input-min',
    priceRangeInputMax: '.price-range__input-max',
    priceRangeDisplayMin: '.price-range__display-min',
    priceRangeDisplayMax: '.price-range__display-max'
  };

  function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
    this.container = container;
    this.onChange = onChange;
    this.onUpdate = onUpdate;
    this.sliderOptions = sliderOptions || {};

    return this.init();
  }

  PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
    init: function () {
      if (!this.container.classList.contains('price-range')) {
        throw new Error('You must instantiate PriceRange with a valid container')
      }

      this.formEl = this.container.closest('form');
      this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
      this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
      this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
      this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
      this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

      this.minRange = parseFloat(this.container.dataset.min) || 0;
      this.minValue = parseFloat(this.container.dataset.minValue) || 0;
      this.maxRange = parseFloat(this.container.dataset.max) || 100;
      this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
      return this.createPriceRange();
    },

    createPriceRange: function () {
      if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
        this.sliderEl.noUiSlider.destroy();
      }

      var slider = noUiSlider.create(this.sliderEl, {
        connect: true,
        step: defaultStep,
        ...this.sliderOptions,
        // Do not allow overriding these options
        start: [this.minValue, this.maxValue],
        range: {
          min: this.minRange,
          max: this.maxRange,
        },
      });

      slider.on('update', values => {
        // this.displayMinEl.innerHTML =  values[0];
        // this.displayMaxEl.innerHTML = values[1];

        document.querySelectorAll('.noUi-handle-lower .noUi-touch-area').forEach((val) => {
          val.innerHTML = values[0].replace(".00", "");
        })
        
        
        document.querySelectorAll('.noUi-handle-upper .noUi-touch-area').forEach((val) => {
          val.innerHTML = values[1].replace(".00", "");
        })
        
        if (this.onUpdate) {
          this.onUpdate(values);
        }
      });

      slider.on('change', values => {
        this.inputMinEl.value = values[0];
        this.inputMaxEl.value = values[1];

        this.inputMinEl.dispatchEvent(new Event('input', { 'bubbles': true }))
        this.inputMaxEl.dispatchEvent(new Event('input', { 'bubbles': true }))
       
      });

      return slider;
    },
  });

  return PriceRange;
})();



const priceRangeEls = document.querySelectorAll('.price-range');
priceRangeEls.forEach((el) => new CsPriceRange(el));